module.exports = __webpack_public_path__ + "img/ORBIS-logo.ea194eec.png";